export default __webpack_public_path__ + "static/media/Graph1.5f9341e8.svg";